import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Who We Are', href: '#about', children: [
    { label: 'About Rigomich', href: '#about' },
    { label: 'Vision & Mission', href: '#values' },
    { label: 'Core Values', href: '#values' },
    { label: 'Certifications', href: '#about' },
  ]},
  { label: 'What We Do', href: '#services', children: [
    { label: 'Civil & Building Construction', href: '/services/civil-construction' },
    { label: 'Electrical & Mechanical Eng.', href: '/services/electrical-mechanical' },
    { label: 'Borehole & Water Engineering', href: '/services/borehole-water' },
    { label: 'General Contracting', href: '/services/general-contracting' },
  ]},
  { label: 'Projects', href: '#projects' },
  { label: 'Why Rigomich', href: '#why' },
  { label: 'Contact', href: '#contact' },
  { label: 'Home', href: '/' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (href, e) => {
    if (href.startsWith('/')) {
      navigate(href);
      return;
    }
    if (href.startsWith('#')) {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
        }, 400);
      } else {
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleMobileLink = (href) => {
    setMobileOpen(false);
    setActiveMobileDropdown(null);
    setTimeout(() => { handleNavClick(href); }, 350);
  };

  return (
    <>
      <header style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, height: 'var(--nav-h)', background: scrolled ? 'rgba(255,255,255,0.98)' : 'rgba(255,255,255,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(26,79,156,0.3)', boxShadow: scrolled ? '0 4px 30px rgba(0,0,0,0.4)' : 'none', transition: 'all 0.3s ease' }}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%', padding: '0 2rem' }}>

          {/* Logo */}
          <a href="#hero" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', flexShrink: 0, marginRight: '2rem' }}>
            <img src="/rigomich-logo.png" alt="Rigomich Logo" style={{ width: 48, height: 48, objectFit: 'contain' }} />
            <div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: '0.95rem', color: '#0d2144', letterSpacing: '0.08em', textTransform: 'uppercase', lineHeight: 1.1 }}>Rigomich</div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.48rem', fontWeight: 400, letterSpacing: '0.18em', color: '#0d2144', textTransform: 'uppercase' }}>Integrated Company Limited</div>
            </div>
          </a>

          {/* Desktop Links */}
          <ul className="desktop-nav" style={{ display: 'flex', alignItems: 'stretch', listStyle: 'none', flex: 1, margin: 0, padding: 0, height: '100%' }}>
            {navLinks.map((link, i) => (
              <li key={i} style={{ position: 'relative', display: 'flex', alignItems: 'stretch' }}
                onMouseEnter={() => link.children && setActiveDropdown(i)}
                onMouseLeave={() => setActiveDropdown(null)}>
                <a href={link.href} onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', padding: '0 0.9rem', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.82rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: activeDropdown === i ? 'var(--blue)' : '#0d2144', textDecoration: 'none', borderBottom: activeDropdown === i ? '3px solid var(--blue)' : '3px solid transparent', transition: 'all 0.2s', whiteSpace: 'nowrap' }}>
                  {link.label}
                  {link.children && <span style={{ fontSize: '0.6rem', display: 'inline-block', transition: 'transform 0.2s', transform: activeDropdown === i ? 'rotate(180deg)' : 'none' }}>&#9660;</span>}
                </a>
                {link.children && activeDropdown === i && (
                  <div style={{ position: 'absolute', top: 'var(--nav-h)', left: 0, minWidth: 240, background: 'white', borderTop: '3px solid var(--blue)', boxShadow: '0 12px 40px rgba(10,22,40,0.2)', animation: 'fadeUp 0.18s ease', zIndex: 100 }}>
                    {link.children.map((child, j) => (
                      <a key={j} href={child.href} onClick={(e) => { e.preventDefault(); handleNavClick(child.href); setActiveDropdown(null); }} style={{ display: 'block', padding: '0.65rem 1.4rem', fontFamily: "'Barlow', sans-serif", fontSize: '0.88rem', color: '#0d2144', textDecoration: 'none', fontWeight: 500, borderLeft: '3px solid transparent', transition: 'all 0.15s' }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f0f5ff'; e.currentTarget.style.borderLeftColor = 'var(--blue)'; e.currentTarget.style.color = 'var(--blue)'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderLeftColor = 'transparent'; e.currentTarget.style.color = '#0d2144'; }}>
                        {child.label}
                      </a>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>

          {/* Desktop CTA + Hamburger */}
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '1rem' }}>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="desktop-cta btn-primary" style={{ padding: '0.5rem 1.4rem', fontSize: '0.78rem' }}><span>Get a Quote</span></a>
            <button onClick={() => setMobileOpen(!mobileOpen)} className="hamburger-btn" aria-label="Toggle menu"
              style={{ display: 'none', background: 'none', border: '1px solid rgba(0,0,50,0.25)', cursor: 'pointer', width: 42, height: 42, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '10px', borderRadius: 2 }}>
              <span style={{ display: 'block', width: 20, height: 2, background: '#0d2144', borderRadius: 1, transition: 'all 0.3s', transform: mobileOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
              <span style={{ display: 'block', width: 20, height: 2, background: '#0d2144', borderRadius: 1, transition: 'all 0.3s', opacity: mobileOpen ? 0 : 1 }} />
              <span style={{ display: 'block', width: 20, height: 2, background: '#0d2144', borderRadius: 1, transition: 'all 0.3s', transform: mobileOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Slide-in Menu */}
      <div style={{ position: 'fixed', top: 'var(--nav-h)', left: 0, right: 0, bottom: 0, background: '#0d2144', zIndex: 998, overflowY: 'auto', transform: mobileOpen ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)', padding: '1rem 1.5rem 3rem' }}>
        {navLinks.map((link, i) => (
          <div key={i} style={{ borderBottom: '1px solid rgba(26,79,156,0.2)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <a href={link.href} onClick={(e) => { e.preventDefault(); if (link.children) { setActiveMobileDropdown(activeMobileDropdown === i ? null : i); } else { handleMobileLink(link.href); } }} style={{ display: 'block', padding: '1rem 0', flex: 1, fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.35rem', fontWeight: 700, color: 'white', textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{link.label}</a>
              {link.children && (
                <button onClick={() => setActiveMobileDropdown(activeMobileDropdown === i ? null : i)}
                  style={{ background: activeMobileDropdown === i ? 'var(--blue)' : 'rgba(26,79,156,0.25)', border: 'none', color: 'white', cursor: 'pointer', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', borderRadius: 2, transition: 'all 0.2s', transform: activeMobileDropdown === i ? 'rotate(180deg)' : 'none' }}>&#9660;</button>
              )}
            </div>
            {link.children && activeMobileDropdown === i && (
              <div style={{ paddingBottom: '0.8rem' }}>
                {link.children.map((child, j) => (
                  <a key={j} href={child.href} onClick={(e) => { e.preventDefault(); setMobileOpen(false); setActiveMobileDropdown(null); setTimeout(() => handleNavClick(child.href), 350); }}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.55rem 0 0.55rem 1rem', fontFamily: "'Barlow', sans-serif", fontSize: '0.88rem', color: 'var(--silver)', textDecoration: 'none', fontWeight: 400, borderLeft: '2px solid var(--blue)', transition: 'color 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'white'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--silver)'}>
                    <span style={{ color: 'var(--blue)', fontSize: '0.6rem' }}>&#8594;</span>{child.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
        <a href="#contact" onClick={(e) => { e.preventDefault(); handleMobileLink('#contact'); }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginTop: '2rem', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.9rem', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', padding: '1rem', background: 'var(--blue)', color: 'white', textDecoration: 'none' }}>
          Get a Quote
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </a>
        <div style={{ marginTop: '2rem', padding: '1.2rem', background: 'rgba(26,79,156,0.15)', borderLeft: '3px solid var(--blue)' }}>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.22em', color: 'var(--blue)', textTransform: 'uppercase', marginBottom: '0.7rem' }}>Quick Contact</div>
          <div style={{ fontSize: '0.88rem', color: 'white', marginBottom: '0.3rem', fontWeight: 500 }}>?? 08036407458</div>
          <div style={{ fontSize: '0.78rem', color: 'var(--silver)', lineHeight: 1.7 }}>?? Jabi, Abuja FCT<br />?? Osogbo, Osun State</div>
        </div>
        <div style={{ marginTop: '1.5rem', textAlign: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.6rem', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' }}>RC: 700638  Est. 2007  Nigeria</div>
      </div>

      {mobileOpen && <div onClick={() => setMobileOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 997, background: 'rgba(0,0,0,0.5)' }} />}

      <style>{`
        @media (max-width: 900px) { .desktop-nav { display: none !important; } .desktop-cta { display: none !important; } .hamburger-btn { display: flex !important; } }
        @media (min-width: 901px) { .hamburger-btn { display: none !important; } }
      `}</style>
    </>
  );
}